module.exports = __webpack_public_path__ + "static/media/loyalty.dd01b4fa.jpg";